module.exports = __webpack_public_path__ + "img/thomas-serer-r-xKieMqL34-unsplash.e23b19e7.jpg";